import LOG_MANAGE from './log-manage'
import SYSTEM_PARAMS from './system-params'
import ACCOUNT_BINDING from './account-binding'
import IMPORT_MANAGE from './import-manage'
import DATA_INITIALIZATION from './data-initialization'
import FILTER_SETTING from './filter-setting'
import ORDER_REQUIRED_SETTING from './order-required-setting'
import ORDER_MISTAKE_CHECK_SETTING from './order-mistake-check-setting'
export default {
	'system-setting': {
		id: 'system-setting',
		label: '系统设置',
		code: '0002',
		child: {
			...LOG_MANAGE,
			...SYSTEM_PARAMS,
			...ACCOUNT_BINDING,
			...IMPORT_MANAGE,
			...DATA_INITIALIZATION,
			...FILTER_SETTING,
			...ORDER_REQUIRED_SETTING,
			...ORDER_MISTAKE_CHECK_SETTING
		}
	}
}
